/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });
  //
  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  let mobileDrawerTopOffsetController = null;

  function setupMobileDrawerTopOffset(mobileMenuDrawer) {
    const setMobileDrawerTopOffset = function () {
      const announcement = document.querySelector('[data-announcement-bar]');
      let visibleHeight = 0;

      if (announcement) {
        const rect = announcement.getBoundingClientRect();
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
      }

      mobileMenuDrawer.style.setProperty('--mobile-drawer-top-offset', `${Math.round(visibleHeight)}px`);
    };

    const syncMobileDrawerTopOffset = function () {
      if (!mobileMenuDrawer.classList.contains('drawer--visible')) return;
      setMobileDrawerTopOffset();
    };

    const handleDrawerOpen = function () {
      setMobileDrawerTopOffset();
      requestAnimationFrame(setMobileDrawerTopOffset);
      setTimeout(setMobileDrawerTopOffset, 120);
    };

    mobileMenuDrawer.addEventListener('theme:drawer:open', handleDrawerOpen);
    window.addEventListener('resize', syncMobileDrawerTopOffset);
    window.addEventListener('scroll', syncMobileDrawerTopOffset, { passive: true });
    document.addEventListener('theme:resize', syncMobileDrawerTopOffset);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncMobileDrawerTopOffset);
      window.visualViewport.addEventListener('scroll', syncMobileDrawerTopOffset);
    }

    return {
      drawer: mobileMenuDrawer,
      destroy() {
        mobileMenuDrawer.removeEventListener('theme:drawer:open', handleDrawerOpen);
        window.removeEventListener('resize', syncMobileDrawerTopOffset);
        window.removeEventListener('scroll', syncMobileDrawerTopOffset);
        document.removeEventListener('theme:resize', syncMobileDrawerTopOffset);

        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', syncMobileDrawerTopOffset);
          window.visualViewport.removeEventListener('scroll', syncMobileDrawerTopOffset);
        }
      }
    };
  }

  function initMobileDrawerTopOffset() {
    const mobileMenuDrawer = document.querySelector('[data-drawer="hamburger"].header__drawer--nested-list');

    if (!mobileMenuDrawer) {
      if (mobileDrawerTopOffsetController) {
        mobileDrawerTopOffsetController.destroy();
        mobileDrawerTopOffsetController = null;
      }

      return;
    }

    if (mobileDrawerTopOffsetController && mobileDrawerTopOffsetController.drawer === mobileMenuDrawer) {
      return;
    }

    if (mobileDrawerTopOffsetController) {
      mobileDrawerTopOffsetController.destroy();
    }

    mobileDrawerTopOffsetController = setupMobileDrawerTopOffset(mobileMenuDrawer);
  }

  document.addEventListener('theme:pagination:done', function (e) {
    const { sectionId } = e.detail;

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const target = document.querySelector('.collection__heading') || section;
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 0;

    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - headerHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    const swatchItems = document.querySelectorAll('.product__color-swatch-item');
    const titleElement = document.querySelector('[data-color-swatch-title]');
    if (swatchItems) {
      const defaultTitle = titleElement ? titleElement.textContent : null;
      const defaultItem = document.querySelector('.product__color-swatch-item.active');
      swatchItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));

          this.classList.add('active');

          const newDescription = this.getAttribute('data-short-description');
          if (newDescription && titleElement) {
            titleElement.textContent = newDescription;
          }
        });
        item.addEventListener('mouseleave', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));
          if (titleElement) {
            titleElement.textContent = defaultTitle;
          }
          if (defaultItem) {
            defaultItem.classList.add('active');
          }
        });
      });
    }

    // Custom scroll behavior
    const elem = document.querySelector('.product__inner');
    if (elem) {
      const pt = window.getComputedStyle(elem, null).getPropertyValue('padding-top');
      const thirdOfNumber = parseInt(pt.replace('px', ''), 10) / 3;
      elem.style.top = `calc(-${pt} + var(--header-height, 47px))`;
    }

    initMobileDrawerTopOffset();

  });

  document.addEventListener('shopify:section:load', initMobileDrawerTopOffset);
  document.addEventListener('shopify:section:unload', function (event) {
    if (
      mobileDrawerTopOffsetController &&
      event.target &&
      typeof event.target.contains === 'function' &&
      event.target.contains(mobileDrawerTopOffsetController.drawer)
    ) {
      mobileDrawerTopOffsetController.destroy();
      mobileDrawerTopOffsetController = null;
    }
  });

  const collectionDescription = document.querySelector('.collection__heading__description');
  if (!collectionDescription) return;

  const collectionDescriptionText = collectionDescription.querySelector('p');
  if (!collectionDescriptionText) return;

  const desktopLimit = collectionDescription.getAttribute('data-max-chars-desktop') || 200;
  const mobileLimit = collectionDescription.getAttribute('data-max-chars-mobile') || 200;

  const fullText = collectionDescriptionText.innerText.trim();
  const isMobile = window.innerWidth < 768;
  const limit = isMobile ? mobileLimit : desktopLimit;

  if (fullText.length <= limit) {
    collectionDescriptionText.innerText = fullText;
    return;
  }

  const shortText = fullText.slice(0, limit);
  collectionDescriptionText.innerHTML = `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

  const button = collectionDescriptionText.querySelector('.read-more-btn');
  let isExpanded = false;

  button.addEventListener('click', function () {
    isExpanded = !isExpanded;
    collectionDescriptionText.innerHTML = isExpanded
      ? `${fullText} <button class="read-more-btn active">${window.theme.strings.readLess}</button>`
      : `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

    collectionDescriptionText.querySelector('.read-more-btn').addEventListener('click', arguments.callee);
  });
})();
